import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_API_KEYS = 'FETCH_API_KEYS'

export const getApiKeysApi = apiCall(
  FETCH_API_KEYS,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/api-keys`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)
